import { render, staticRenderFns } from "./SiteInfo.vue?vue&type=template&id=544a7dd2&scoped=true"
import script from "./SiteInfo.vue?vue&type=script&lang=js"
export * from "./SiteInfo.vue?vue&type=script&lang=js"
import style0 from "./SiteInfo.vue?vue&type=style&index=0&id=544a7dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544a7dd2",
  null
  
)

export default component.exports